import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { getThresholdsColorForValue } from "../../lib/thresholds";
import style from "./style.module.scss";
export default function Gauge(props) {
    const { value, max, suffix, thresholds } = props;
    const showValue = props.showValue === false ? props.showValue : true;
    const percent = (value / max) * 100;
    let barColor = "var(--low-emphasis)";
    let textColor = "var(--high-emphasis)";
    if (typeof thresholds !== "undefined") {
        barColor = getThresholdsColorForValue(thresholds, value);
        textColor = barColor;
    }
    let columns = "30px 1fr";
    if (suffix) {
        columns = "45px 1fr";
    }
    let displayValue = (_jsxs("div", { style: { color: textColor }, children: [value, suffix] }));
    if (!showValue) {
        columns = "1fr";
        displayValue = null;
    }
    if (props.barColor) {
        barColor = props.barColor;
    }
    return (_jsxs("div", { className: classNames(style["gauge"], "qa-gauge"), style: { gridTemplateColumns: columns }, children: [displayValue, _jsx("div", { className: style["gauge__bar"], children: _jsx("div", { className: style["gauge__bar-level"], style: { width: percent + "%", backgroundColor: barColor } }) })] }));
}
